import React,{useState} from 'react';
import {Link} from 'react-router-dom';
import {motion,AnimatePresence} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiHome,FiBrick,FiLayers,FiSquare,FiTool,FiGrid}=FiIcons;

const MegaMenu=()=> {
  const [hoveredService,setHoveredService]=useState(null);
  
  const services=[
    {
      title: 'Rohbau',
      path: '/leistungen/rohbau',
      icon: FiHome,
      description: 'Professionelle Rohbauarbeiten vom Fundament bis zum Dach. Wir schaffen das solide Grundgerüst für Ihr Bauvorhaben.',
      video: 'https://canv.wasacon.com/rudt-bau/_assets/video/d15bd0722d69ec9507ccd5d15254038b.mp4',
      features: [
        'Fundamente und Bodenplatten',
        'Mauerwerk',
        'Betonarbeiten',
        'Dachstuhl-Vorbereitung'
      ]
    },
    {
      title: 'Klinkerarbeiten',
      path: '/leistungen/klinkerarbeiten',
      icon: FiBrick,
      description: 'Hochwertige Klinkerverblendungen und Ziegelfassaden für langlebige und ästhetische Außenwände.',
      image: 'https://canv.wasacon.com/rudt-bau/_assets/media/0c87bfd41e772cb12be78235e6f7f53e.jpg',
      features: [
        'Klinkerfassaden',
        'Verblendmauerwerk',
        'Restaurierung',
        'Fugensanierung'
      ]
    },
    {
      title: 'Putzarbeiten',
      path: '/leistungen/putzarbeiten',
      icon: FiLayers,
      description: 'Innen- und Außenputz in verschiedenen Ausführungen für Ihre perfekte Oberflächengestaltung.',
      video: 'https://canv.wasacon.com/rudt-bau/_assets/video/097822a36f47d07143ede72d186f793a.mp4',
      features: [
        'Innenputz',
        'Außenputz',
        'Dekorputz',
        'Wärmedämmputz'
      ]
    },
    {
      title: 'Betonarbeiten',
      path: '/leistungen/betonarbeiten',
      icon: FiSquare,
      description: 'Fundamente, Bodenplatten und Betonkonstruktionen in höchster Qualität.',
      video: 'https://canv.wasacon.com/rudt-bau/_assets/video/72625f99f6ee755b2ff4d9216c76f3b8.mp4',
      features: [
        'Betonfundamente',
        'Bodenplatten',
        'Stützmauern',
        'Betonreparaturen'
      ]
    },
    {
      title: 'Maurerarbeiten',
      path: '/leistungen/maurerarbeiten',
      icon: FiTool,
      description: 'Klassische Maurerarbeiten mit traditionellem Handwerk und modernen Techniken.',
      video: 'https://canv.wasacon.com/rudt-bau/_assets/video/668b179f9a262e8560d069db74b21f2c.mp4',
      features: [
        'Mauerwerksbau',
        'Reparaturen',
        'Sanierung',
        'Umbauarbeiten'
      ]
    },
    {
      title: 'Pflasterverlegung',
      path: '/leistungen/pflasterverlegung',
      icon: FiGrid,
      description: 'Professionelle Verlegung von Pflastersteinen für Einfahrten, Gehwege und Terrassen.',
      image: 'https://canv.wasacon.com/rudt-bau/_assets/media/ae28306617446087eb526827f0f28121.jpg',
      features: [
        'Einfahrten',
        'Gehwege',
        'Terrassen',
        'Plätze'
      ]
    }
  ];

  const handleServiceClick=(e,path)=> {
    e.preventDefault();
    // Scrollt sofort nach oben
    window.scrollTo(0,0);
    // Kurz danach zur Seite navigieren
    setTimeout(()=> {
      window.location.hash=path;
    },50);
  };

  return (
    <motion.div
      initial={{opacity: 0,y: -20}}
      animate={{opacity: 1,y: 0}}
      exit={{opacity: 0,y: -20}}
      className="absolute top-full left-0 right-0 shadow-2xl border-t border-gray-200"
      style={{minHeight: '450px'}}
    >
      {/* Background Container - Weiß mit Media Overlay */}
      <div className="absolute inset-0 bg-white">
        <AnimatePresence>
          {hoveredService === 'Rohbau' && (
            <motion.div 
              key="rohbau-video-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Video Background */}
              <motion.video
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="https://canv.wasacon.com/rudt-bau/_assets/video/d15bd0722d69ec9507ccd5d15254038b.mp4" type="video/mp4" />
              </motion.video>
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
          {hoveredService === 'Klinkerarbeiten' && (
            <motion.div 
              key="klinkerarbeiten-image-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Image Background */}
              <motion.img
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                src="https://canv.wasacon.com/rudt-bau/_assets/media/0c87bfd41e772cb12be78235e6f7f53e.jpg"
                alt="Klinkerarbeiten背景"
                className="absolute inset-0 w-full h-full object-cover"
              />
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
          {hoveredService === 'Putzarbeiten' && (
            <motion.div 
              key="putzarbeiten-video-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Video Background */}
              <motion.video
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="https://canv.wasacon.com/rudt-bau/_assets/video/097822a36f47d07143ede72d186f793a.mp4" type="video/mp4" />
              </motion.video>
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
          {hoveredService === 'Betonarbeiten' && (
            <motion.div 
              key="betonarbeiten-video-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Video Background */}
              <motion.video
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="https://canv.wasacon.com/rudt-bau/_assets/video/72625f99f6ee755b2ff4d9216c76f3b8.mp4" type="video/mp4" />
              </motion.video>
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
          {hoveredService === 'Maurerarbeiten' && (
            <motion.div 
              key="maurerarbeiten-video-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Video Background */}
              <motion.video
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                className="absolute inset-0 w-full h-full object-cover"
                autoPlay
                muted
                loop
                playsInline
              >
                <source src="https://canv.wasacon.com/rudt-bau/_assets/video/668b179f9a262e8560d069db74b21f2c.mp4" type="video/mp4" />
              </motion.video>
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
          {hoveredService === 'Pflasterverlegung' && (
            <motion.div 
              key="pflasterverlegung-image-container"
              initial={{opacity: 0}}
              animate={{opacity: 1}}
              exit={{opacity: 0}}
              className="absolute inset-0"
            >
              {/* Image Background */}
              <motion.img
                initial={{opacity: 0}}
                animate={{opacity: 0.3}}
                exit={{opacity: 0}}
                src="https://canv.wasacon.com/rudt-bau/_assets/media/ae28306617446087eb526827f0f28121.jpg"
                alt="Pflasterverlegung背景"
                className="absolute inset-0 w-full h-full object-cover"
              />
              {/* Dark Overlay for better text visibility */}
              <div className="absolute inset-0 bg-black/20"></div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>

      {/* Content Container */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service,index)=> (
            <motion.div
              key={service.title}
              initial={{opacity: 0,y: 20}}
              animate={{opacity: 1,y: 0}}
              transition={{delay: index * 0.1}}
              className="group"
              onMouseEnter={()=> setHoveredService(service.title)}
              onMouseLeave={()=> setHoveredService(null)}
            >
              <Link
                to={service.path}
                onClick={(e)=> handleServiceClick(e,service.path)}
                className={`block p-6 rounded-lg transition-all duration-200 ${
                  hoveredService === service.title
                    ? 'bg-white/95 backdrop-blur-sm shadow-xl'
                    : (hoveredService === 'Rohbau' || hoveredService === 'Klinkerarbeiten' || hoveredService === 'Putzarbeiten' || hoveredService === 'Betonarbeiten' || hoveredService === 'Maurerarbeiten' || hoveredService === 'Pflasterverlegung')
                    ? 'bg-white/90 backdrop-blur-sm hover:bg-white/95'
                    : 'bg-white shadow-md hover:shadow-lg'
                }`}
              >
                <div className="flex items-center space-x-3 mb-3">
                  <div
                    className={`w-10 h-10 rounded-lg flex items-center justify-center transition-all duration-200 ${
                      hoveredService === service.title
                        ? 'bg-[#2a5291] scale-110'
                        : (hoveredService === 'Rohbau' || hoveredService === 'Klinkerarbeiten' || hoveredService === 'Putzarbeiten' || hoveredService === 'Betonarbeiten' || hoveredService === 'Maurerarbeiten' || hoveredService === 'Pflasterverlegung')
                        ? 'bg-[#3466ad]'
                        : 'bg-[#3466ad] group-hover:bg-[#2a5291]'
                    }`}
                  >
                    <SafeIcon icon={service.icon} className="w-5 h-5 text-white flex-shrink-0" />
                  </div>
                  <h3
                    className={`text-lg font-semibold transition-colors duration-200 ${
                      hoveredService === service.title
                        ? 'text-[#2a5291]'
                        : 'text-gray-900 group-hover:text-[#3466ad]'
                    }`}
                  >
                    {service.title}
                  </h3>
                </div>
                <p
                  className={`text-sm mb-4 leading-relaxed transition-all duration-200 ${
                    hoveredService === service.title
                      ? 'text-gray-700'
                      : 'text-gray-600'
                  }`}
                >
                  {service.description}
                </p>
                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li
                      key={idx}
                      className="flex items-center space-x-2 text-sm transition-colors duration-200"
                    >
                      <div
                        className={`w-1.5 h-1.5 rounded-full transition-all duration-200 ${
                          hoveredService === service.title
                            ? 'bg-[#2a5291] scale-150'
                            : (hoveredService === 'Rohbau' || hoveredService === 'Klinkerarbeiten' || hoveredService === 'Putzarbeiten' || hoveredService === 'Betonarbeiten' || hoveredService === 'Maurerarbeiten' || hoveredService === 'Pflasterverlegung')
                            ? 'bg-[#3466ad]'
                            : 'bg-[#3466ad]'
                        }`}
                      ></div>
                      <span className="text-gray-600">{feature}</span>
                    </li>
                  ))}
                </ul>
              </Link>
            </motion.div>
          ))}
        </div>

        <div className={`mt-8 pt-6 border-t text-center transition-colors duration-200 ${
          (hoveredService === 'Rohbau' || hoveredService === 'Klinkerarbeiten' || hoveredService === 'Putzarbeiten' || hoveredService === 'Betonarbeiten' || hoveredService === 'Maurerarbeiten' || hoveredService === 'Pflasterverlegung')
            ? 'border-gray-200/50'
            : 'border-gray-200'
        }`}>
          <Link 
            to="/leistungen" 
            onClick={(e)=> handleServiceClick(e,'/leistungen')}
            className={`inline-flex items-center space-x-2 px-6 py-3 rounded-lg font-medium transition-all duration-200 shadow-lg hover:shadow-xl ${
              (hoveredService === 'Rohbau' || hoveredService === 'Klinkerarbeiten' || hoveredService === 'Putzarbeiten' || hoveredService === 'Betonarbeiten' || hoveredService === 'Maurerarbeiten' || hoveredService === 'Pflasterverlegung')
                ? 'bg-[#3466ad] text-white hover:bg-[#2a5291]'
                : 'bg-[#3466ad] text-white hover:bg-[#2a5291]'
            }`}
          >
            <span>Alle Leistungen anzeigen</span>
            <SafeIcon icon={FiIcons.FiArrowRight} className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default MegaMenu;